export interface InvalidPath {
    readonly type: "invalid-path";
    readonly path: string;
}
